import { render, staticRenderFns } from "./TabEndereco.vue?vue&type=template&id=7572fbf8&"
import script from "./TabEndereco.vue?vue&type=script&lang=js&"
export * from "./TabEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports